<template>
    <router-link class="card_container"
      v-bind:to="{name:'project', params:{title:titleUrl, tagKey}}" :class="{pc:pcStyle}"
    >
      <div ref="focusImg" class="card" :class="{none :!isDisplay, 'card-mouseover':cardHover} " v-on:mouseover="projectMouseover" v-on:mouseleave="projectMouseleave">
        <img class="works__img-flame" src="/assets/img/common/flame.svg" />
        <img class="works__img-flame" src="/assets/img/common/flame.svg" />
        <img class="works__img-flame" src="/assets/img/common/flame.svg" />
        <img class="works__img-flame" src="/assets/img/common/flame.svg" />
        <img class="works__img-project" v-bind:src="imgSrc" />
        <div class="work__text" :class="{none :!isDisplay,title_hidden:pcTitle}">
          <p class="work__text__title">{{ title }}</p>
          <p class="work__text__en font__roboto">{{ titleEn }}</p>
          <p class="work__text__year__tag font__roboto">{{ projectYear }},<span style="margin-left:4px;">{{ tag }}</span></p>
        </div>
      </div>
      <div class="wark_text_mob" :class="{none :!isDisplay,title_hidden:mobTitle}">
        <p class="work__text__title">{{ title }}</p>
        <p class="work__text__en font__roboto">{{ titleEn }}</p>
        <p class="work__text__year__tag font__roboto">{{ projectYear }},<span style="margin-left:4px;">{{ tag }}</span></p>
      </div>
    </router-link>
</template>

<script>
export default {
  props: {
    id: String,
    tagKey: String,
    title: String,
    titleEn: String,
    projectYear: String,
    tag: String,
    imgSrc: String,
    isDisplay: Boolean,
    titleUrl: String,
    // ブラウザ表示領域中央位置
    mobFocusHeightMiddle: Number,
    
  },
  data() {
    return{
      // pc独自スタイル
      pcStyle: true,
      // モバイルタイトル表示・非表示
      pcTitle: false,
      // モバイルタイトル表示・非表示
      mobTitle: true,
      // ホバースタイル
      cardHover: false
    }
  },
  mounted() {
    /**
     * モバイル時のフォーカス処理
     */
    if (navigator.userAgent.indexOf('iPhone') > 0 ||
      navigator.userAgent.indexOf('iPad') > 0 ||
      navigator.userAgent.indexOf('Android') > 0) {
        // pcのスタイルを不可にする
        this.pcStyle = false;
        // モバイル時のCSS適応
        this.pcTitle = true;
        this.mobTitle = false;
        // スクロールイベント監視・メソッド呼び出し
        window.addEventListener('scroll',this.handScroll);
      } else {
        // PC時のCSS適応
        this.pcTitle = false;
        this.mobTitle = true;
      }
  },
  methods: {
    handScroll: function() {
      const targetElement = this.$refs.focusImg;
      var targetElementTop = targetElement.getBoundingClientRect().top;
      var targetElementBottom = targetElement.getBoundingClientRect().bottom;
      // モバイルのピント領域に該当する
      if (targetElementTop < this.mobFocusHeightMiddle &&
        this.mobFocusHeightMiddle < targetElementBottom) {
        this.cardHover = true;
      } else {
        this.cardHover = false;
      }
    },
    /**
     * PCマウス操作アクション
     * 作品フォーカス時
     */
    projectMouseover: function() {
      this.cardHover = true;
    },
    /**
     * PCマウス操作アクション
     * 作品フォーカス外
     */
    projectMouseleave: function() {
      this.cardHover = false;

    }
  }
}
</script>

<style lang="scss" scoped>
// 共通
//タイトルの表示・非表示切替
.title_hidden {
  display: none;
}
.none {
  display: none;
}
.card {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 60vw;
  vertical-align: bottom;
  overflow: hidden;
    &.none {
    display: none;
  }
}
// pcタイトルスタイル
.work__text {
  position: absolute;
  z-index: 1;
  bottom: 10%;
  margin-left: 5%;
  margin-right: 5%;
  color: #ffffff;
  line-height: normal;
  transition: opacity 0.5s linear;
  text-shadow: 1px 1px 5px #505050;
    .work__text__title {
      white-space: pre-wrap;
      font-size: 3.5vw;
      font-weight: bold;
      letter-spacing: 1.5px;
      -moz-font-feature-settings: "palt";
      -webkit-font-feature-settings: "palt";
      font-feature-settings: "palt";
    }
    .work__text__en {
      font-size: 2.3vw;
      letter-spacing: 0.05vw;
    }
    .work__text__year__tag {
      margin-top: 10px;
      font-size: 2vw;
      letter-spacing: 0.05vw;
    }
}
// モバイルタイトルスタイル
.wark_text_mob {
    color: #ffffff;
    line-height: normal;
    margin: 3vw 6.5vw 8vw 6.5vw;
    .work__text__title {
      white-space: pre-wrap;
      font-size: 5vw;
      font-weight: bold;
      letter-spacing: 1.5px;
      line-height: 1.3em;
      -moz-font-feature-settings: "palt";
      -webkit-font-feature-settings: "palt";
      font-feature-settings: "palt";
    }
    .work__text__en {
      font-size: 3.8vw;
      letter-spacing: 0.2vw;
      margin-top: 1vw;
      line-height: 1.45em;

    }
    .work__text__year__tag {
      margin-top: 10px;
      font-size: 3vw;
      letter-spacing: 0.2vw;
    }
}
.works__img-project {
  position: absolute;
  width: calc(100% + 10px);
  height: calc(100% + 10px);
  margin: -5px;
  transition: filter 0.1s linear,transform 0.1s linear;
  filter: blur(5px) brightness(130%);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

// フレーム
.works__img-flame {
  position: absolute;
  width: 15%;
  visibility: hidden;
  z-index: 1;
  &:nth-child(1) {
    top: 14%;
    right: 10%;
  }
  &:nth-child(2) {
    top: 14%;
    left: 10%;
    -webkit-transform: scale(-1, 1);
    transform: scale(-1, 1);
  }
  &:nth-child(3) {
    bottom: 14%;
    right: 10%;
    -webkit-transform: scale(1, -1);
    transform: scale(1, -1);
  }
  &:nth-child(4) {
    bottom: 14%;
    left: 10%;
    -webkit-transform: scale(-1, -1);
    transform: scale(-1, -1);
  }
}
// フォーカス処理
.card.card-mouseover .works__img-project {
  transform: scale(1.05);
  filter: blur(0px) brightness(100%);
  transition: filter 0.5s ease-in, transform 0.5s linear;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.card.card-mouseover .works__img-flame {
  visibility: visible;
}
.card.card-mouseover .work__text {
  opacity: 0;
}
// 最大フォントサイズ指定
@media screen and (min-width:1550px){
  .work__text__title {
   font-size: 23.5px;  
  }
  .work__text__en {
    font-size: 15.5px;
  }
  .work__text__year__tag {
    font-size: 13.95px;
  }
}
// PC
@media screen and (min-width: 768px) {
  .pc{
    .card {
      width: 50%;
      height: 30vw;
      }
    }
    // pcタイトルスタイル
.work__text {
  position: absolute;
  z-index: 1;
  bottom: 10%;
  color: #ffffff;
  line-height: normal;
  transition: opacity 0.5s linear;
  text-shadow: 1px 1px 5px #505050;
    .work__text__title {
      font-size: 1.5vw;
      font-weight: bold;
      letter-spacing: 1.5px;
      -moz-font-feature-settings: "palt";
      -webkit-font-feature-settings: "palt";
      font-feature-settings: "palt";
    }
    .work__text__en {
      font-size: 1vw;
      letter-spacing: 0.05vw;
    }
    .work__text__year__tag {
      margin-top: 10px;
      font-size: 0.9vw;
      letter-spacing: 0.05vw;
    }
}
  }
</style>